import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight, X } from "lucide-react";
import { toast } from "sonner";
import { useSubscription } from "@/contexts/SubscriptionContext";

export default function UpgradeOverlay({ requiredTier = "pro", title, body, onClose }) {
  const { plans, startCheckout } = useSubscription();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  // For "pro" gated tools, offer the Pro plan; for basic, Creator (basic).
  const targetKey = requiredTier === "pro" ? "pro" : "basic";
  const plan = plans[targetKey];
  const badgeLabel = targetKey === "basic" ? "Creator" : "Pro";
  if (!plan) return null;

  const upgrade = async () => {
    setBusy(true);
    try {
      const url = await startCheckout(targetKey);
      window.location.href = url;
    } catch (e) {
      toast.error("Could not start checkout");
      setBusy(false);
    }
  };

  return (
    <div data-testid="upgrade-overlay" className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0A2342]/40 backdrop-blur-sm animate-fade-up">
      <div className="dms-card p-8 max-w-md w-full relative">
        {onClose && (
          <button data-testid="upgrade-close" onClick={onClose} className="absolute top-4 right-4 text-[#64748B] hover:text-[#0A2342]">
            <X className="w-4 h-4" />
          </button>
        )}
        <div className="w-12 h-12 rounded-full bg-[#4FD1C5]/15 flex items-center justify-center mb-5">
          <Lock className="w-5 h-5 text-[#1D4E89]" />
        </div>
        <div className="dms-label mb-2">{badgeLabel} plan</div>
        <h2 className="font-heading font-bold text-2xl text-[#0A2342]">{title || `Unlock ${badgeLabel} tools`}</h2>
        <p className="mt-3 text-[#475569] text-[15px] leading-relaxed">
          {body || `This tool is part of the ${badgeLabel} plan.`}
        </p>
        <div className="mt-6 dms-card bg-[#F8FAFC] p-4 flex items-baseline justify-between">
          <div>
            <div className="font-heading font-bold text-[28px] text-[#0A2342]">&euro;{plan.amount.toFixed(2)}</div>
            <div className="text-xs text-[#64748B]">per month · 7-day free trial</div>
          </div>
          <div className="dms-badge">{badgeLabel}</div>
        </div>
        <div className="mt-6 flex gap-3">
          <button data-testid="upgrade-go" onClick={upgrade} disabled={busy} className="flex-1 dms-btn-accent">
            {busy ? "Opening checkout…" : <>Upgrade to {badgeLabel} <ArrowRight className="w-4 h-4" /></>}
          </button>
          <button data-testid="upgrade-later" onClick={() => (onClose ? onClose() : nav("/dashboard"))} className="dms-btn-ghost">
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
